module.exports = {"select":"Seleccionar"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/SelectSystem.json
// module id = 610
// module chunks = 1